import styled from 'styled-components';

import { $dmSansFontFamily, colorsPalettes, setFontVariant } from '@similarweb/styles';

import { StyledTrafficChangeIndicator } from '../../../components/TrafficChangeIndicator/styles';

export const StyledTrafficVisitsInfo = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  width: 100%;
  min-height: 50px;
  margin-top: 26px;
  text-align: center;
`;

export const StyledTrafficVisitsInfoRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;

  ${StyledTrafficChangeIndicator} {
    align-self: center;
  }
`;

export const StyledTrafficVisitsInfoBold = styled.span`
  font-family: ${$dmSansFontFamily};
  font-size: 26px;
  font-weight: 400;
  line-height: 34px;
  color: ${colorsPalettes.carbon[400]};
  margin-right: 5px;
`;

export const StyledTrafficVisitsDate = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  padding: 0 16px;
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[250])};
  font-size: 10px;
`;

export const StyledTrafficVisitsChart = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
